module.exports = __webpack_public_path__ + "static/media/windows.fda9ea20.svg";